import React, { useState, useEffect, useRef } from "react";
import RecentFilesTable from "../components/RecentFilesTable";
import FolderCard from "../components/FolderCard";
import { IoAddCircleOutline } from "react-icons/io5";
import { BsFiletypePdf, BsFolder } from "react-icons/bs";
import { CgScrollV } from "react-icons/cg";
import { Dropdown } from "flowbite-react";
import UploadFileModal from "../components/UploadFileModal";
import CreateAndRenameFolderModal from "../components/CreateAndRenameFolderModal";
import { useFileManager } from "../context/FileMangerContextHelper";
import { useModal } from "../context/ModalContextHelper";

const FilesManagerPage = () => {
  const {
    openModalFileUpload,
    setOpenModalFileUpload,
    openModalFolder,
    setOpenModalFolder,
    folderModalFor,
    setFolderModalFor,
  } = useModal();

  const [selectedFolder, setSelectedFolder] = useState({
    folderId: null,
    name: "",
  });

  const { folders, getUserFolders } = useFileManager();
  const scrollContainerRef = useRef(null);
  const [scrollDirection, setScrollDirection] = useState("down");
  const handleToggleScroll = () => {
    if (scrollContainerRef.current) {
      if (scrollDirection === "down") {
        const scrollableHeight =
          scrollContainerRef.current.scrollHeight -
          scrollContainerRef.current.clientHeight;
        scrollContainerRef.current.scrollTop = scrollableHeight;
        setScrollDirection("up");
      } else {
        scrollContainerRef.current.scrollTop = 0;
        setScrollDirection("down");
      }
    }
  };

  useEffect(() => {
    getUserFolders();
  }, []);

  return (
    <div className="h-full flex flex-col">
      <div className="flex-1 flex flex-col justify-start border border-gray-200 rounded-md p-4 mb-4 bg-white shadow-md w-full overflow-y-auto">
        <div className="w-full mb-2 flex flex-row justify-between">
          <div className="flex items-center">
            <Dropdown
              placement="right-end"
              renderTrigger={() => (
                <button className="rounded-md bg-[#003464] px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-[#c96b1a] flex flex-row justify-between items-center hover:shadow-lg h-full w-full">
                  <IoAddCircleOutline size={20} color="#FFF" title="Upload" />
                  <span className="hidden pl-2 md:block">Upload</span>
                </button>
              )}
            >
              <Dropdown.Item
                icon={BsFiletypePdf}
                theme={{ icon: "white mr-1" }}
                onClick={() => {
                  setOpenModalFileUpload("dismissible");
                }}
              >
                File
              </Dropdown.Item>
              <Dropdown.Item
                icon={BsFolder}
                theme={{ icon: "white mr-1" }}
                onClick={() => {
                  setFolderModalFor("create");
                  setOpenModalFolder("popup");
                }}
              >
                Folder
              </Dropdown.Item>
            </Dropdown>
            <UploadFileModal
              openModal={openModalFileUpload}
              setOpenModal={setOpenModalFileUpload}
              folders={folders}
              view={"file-manager-view"}
            />
            <CreateAndRenameFolderModal
              openModal={openModalFolder}
              setOpenModal={setOpenModalFolder}
              modalFor={folderModalFor}
              folderId={selectedFolder.folderId}
              _folderName={selectedFolder.title}
            />
          </div>
          <form className="lg:w-1/5">
            <label
              htmlFor="default-search"
              className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
            >
              Search
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                  className="w-4 h-4 text-gray-500 dark:text-gray-400"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  />
                </svg>
              </div>
              <input
                type="search"
                id="default-search"
                className="block w-full px-3 py-3 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-[#003464] focus:border-[#003464]"
                placeholder="Search"
                required
              />
            </div>
          </form>
        </div>
        <div className="overflow-y-auto h-full" ref={scrollContainerRef}>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
            {folders.map((folder) => {
              return (
                <FolderCard
                  key={folder.id}
                  folderId={folder.id}
                  title={folder.name}
                  fileCount={folder.total_files}
                  fileSize={folder.total_capacity}
                  setOpenModal={setOpenModalFolder}
                  setFolderModalFor={setFolderModalFor}
                  setSelectedFolder={setSelectedFolder}
                />
              );
            })}
          </div>
        </div>
        <div className="relative w-full flex items-center justify-center hidden md:block mb-4">
          <button className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <CgScrollV
              size={30}
              className="text-gray-500"
              onClick={handleToggleScroll}
            />
          </button>
        </div>
      </div>

      <div className="flex-1 border p-4 rounded-md mb-4 md:flex-row bg-white overflow-y-auto">
        <div className="w-full mb-2 flex flex-row justify-start">
          <h1 className="text-xl font-bold tracking-tight text-gray-900 py-2">
            Recent Files
          </h1>
        </div>
        <RecentFilesTable />
      </div>
    </div>
  );
};

export default FilesManagerPage;
